import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getSearchUsers = (searchText, pageNumber, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.USER_MANAGEMENT.GET_SEARCH_USERS(
      searchText,
      pageNumber,
      pageSize
    ),
    "",
    cancelToken
  );
};

export default getSearchUsers;
